<template>
  <div class="d-dropdown-container" :class="{'d-dropdown-container--active': isDropDown}"
       v-on-clickaway="onClickOutside">
    <div class="d-dropdown__title" @click="setDropdown" v-on-clickaway="setDropdownFromClick" ref="d_parent">
      <slot name="title"></slot>
      <div class="d-dropdown__title__circle" v-if="isShowDots">
        <slot name="d-dropdown__icon">
          <span class="icon-more2"></span>
        </slot>
      </div>
    </div>
    <div class="d-dropdown text-dark" id="d-dropdown__d-child" ref="d_child" v-if="isDropDown"
         :class="{'d-dropdown--animate': isPopperReady, 'd-dropdown--show': isPopperDone}">
      <slot name="list">
        <ul>
          <li>Rename</li>
          <li>Help</li>
          <li class="d-item-warning">Try</li>
        </ul>
      </slot>
    </div>
  </div>
</template>

<script>
import {mixin as clickaway} from 'vue-clickaway'
import {createPopper} from '@popperjs/core'

export default {
  mixins: [clickaway],
  props: {
    appendToBody: {
      type: Boolean,
      default: true
    },
    isShowDots: {
      type: Boolean,
      default: true
    },
    isBottomStart: {
      type: Boolean,
      default: true
    },
    propOffset: {
      type: Array,
      default: () => null
    },
    isCloseOnDropdownClick: {
      type: Boolean,
      default: true
    },
    closeFromProp: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      isDropDown: false,
      isPopperDone: false,
      isPopperReady: false
    }
  },
  watch: {
    closeFromProp (val, oldVal) {
      if (this.isDropDown) {
        this.setDropdown()
      }
    }
  },
  methods: {
    createPopper () {
      this.isPopperReady = false
      this.isPopperDone = false
      let dChild = this.$refs.d_child
      let dParent = this.$refs.d_parent
      if (this.appendToBody) {
        document.getElementById('djs-body-click').appendChild(dChild)
      }
      let dOffset = this.isShowDots ? [5, 5] : [0, -20]
      if (this.propOffset) {
        dOffset = this.propOffset
      }
      const dPlacement = this.isBottomStart ? 'bottom-start' : 'bottom-end'
      createPopper(dParent, dChild, {
        placement: dPlacement,
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: dOffset
            }
          }
        ]
      })
      setTimeout(_ => {
        this.isPopperReady = true
        this.isPopperDone = true
      }, 0)
    },
    setDropdown () {
      this.isDropDown = !this.isDropDown
      if (this.isDropDown) {
        this.$emit('open')
        this.$nextTick(_ => {
          this.createPopper()
        })
      } else {
        this.$emit('onClose')
        this.isPopperReady = false
        this.isPopperDone = false
      }
    },
    setDropdownFromClick () {
      if (!this.isDropDown || !this.isCloseOnDropdownClick) {
        return
      }
      this.setDropdown()
    },
    onClickOutside () {
      if (this.isCloseOnDropdownClick) {
        return
      }
      if (this.isDropDown) {
        this.setDropdown()
      }
    }
  },
  beforeDestroy () {
    // remove the dropdown from the DOM
    let dChild = this.$refs.d_child
    if (dChild) {
      dChild.remove()
    }
  }
}
</script>

<style>
@import '../../assets/css/variables.css';

.d-dropdown-container {
  position: relative;
}

.d-dropdown__title {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 14px;
}

.d-dropdown__title__circle {
  width: 30px;
  height: 30px;
  font-size: 1rem;
  cursor: pointer;
  border-radius: 50%;
  transition: background-color .3s;
  display: flex;
  align-items: center;
  justify-content: center;
  /* background-color: hsla(0,0%,100%,.16); */
}

.d-dropdown__title__circle:hover, .d-dropdown-container--active .d-dropdown__title__circle {
  background-color: rgba(0, 0, 0, .16);
}

.d-dropdown {
  position: absolute;
  z-index: 19990;
  top: calc(100% - 3px);
  left: 0;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 3px 8px rgba(0, 0, 0, .24);
  height: auto;
  outline: none;
  text-align: left;
  padding: 0.5rem;
  min-width: 100px;
  user-select: none;
  opacity: 0;
  margin-top: -10px !important;
}

.d-dropdown.d-dropdown--animate {
  transition: opacity 0.25s, margin-top 0.25s;
}

.d-dropdown.d-dropdown--show {
  opacity: 1;
  margin-top: 0px !important;
  z-index: 123123123123123;
}

.d-dropdown > ul,
.d-dropdown > ul > li > ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.d-dropdown > ul > li,
.d-dropdown > ul > li > ul > li {
  cursor: pointer;
  font-size: 13px;
  line-height: 18px;
  padding: 0.5rem;
  font-weight: normal;
  position: relative;
}

.d-dropdown > ul > li:hover,
.d-dropdown > ul > li > ul > li:hover {
  background-color: #f5f6f7;
  border-radius: 6px;
}

.d-dropdown > ul > li > span[class^="icon"] {
  margin-right: 5px;
}

.d-dropdown > ul > li > a {
  font-weight: normal !important;
  color: var(--grey);
  background: transparent !important;
  text-decoration: none !important;
  margin: 0 !important;
}

.d-dropdown > ul > li > ul {
  position: absolute;
  top: 0;
  right: 100%;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 3px 8px rgba(0, 0, 0, .24);
  min-width: 100px;
  width: max-content;
  padding: 5px;
  opacity: 0;
  margin-right: -10px;
  transition: opacity 0.25s, margin-right 0.25s;
  pointer-events: none;
}

.d-dropdown > ul > li:hover > ul {
  opacity: 1;
  margin-right: 0;
  pointer-events: initial;
}

.d-item-warning {
  color: var(--danger);
}

.d-dropdown-enter-active, .d-dropdown-leave-active {
  transition: opacity 0.25s, transform 0.25s;
}

.d-dropdown-enter, .d-dropdown-leave-active {
  opacity: 0;
  transform: translateY(-10px);
}

.title--grey .d-dropdown__title {
  color: #728195;
}

</style>



// WEBPACK FOOTER //
// DDropdown.vue?fe22cf7e